var _linearGradient, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLatex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    viewBox: "0 0 128 128",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 128,
    y1: 128,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5d5d5d"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24.827171 12.268815v3.124898h5.505773v37.052362h-5.505773v3.050496h34.671488v-10.788339h-3.571312v7.291429h-19.716619v-36.605948h5.505773v-3.124898zm56.917786 3.273702-15.475686 40.177261h-3.794519v3.124898h12.201983v-3.124898h-4.761749l3.645714-9.449097h18.15417l3.645714 9.449097h-4.836152v3.124898h15.773298v-3.124898h-4.24094l-15.475681-40.177261zm.96723 6.99382 7.886648 20.609446h-15.847698zm-70.235804 36.605948v10.19312h3.571312v-6.69621h12.7228v36.754753h-5.505773v3.050492h16.88933v-3.050492h-5.505773v-36.754753h12.722799v6.69621h3.49691v-10.19312zm61.605133 3.050496v3.050496h4.612945l12.648397 18.972595-12.42519 18.154168h-4.984956v3.0505h14.285248v-3.0505h-5.580175l10.565131-15.475684 10.341924 15.475684h-5.13376v3.0505h17.11254v-3.0505h-4.61295l-13.690028-20.46064 11.457958-16.666123h4.91056v-3.050496h-14.21085v3.050496h5.58018l-9.523504 13.987639-9.300291-13.987639h5.133761v-3.050496zm-31.993004 11.606764v3.050496h5.505773v37.126769h-5.505773v3.05049h35.341109v-9.5979h-3.571312v6.02659h-20.311837v-18.079768h14.136444v5.431368h3.571312v-14.43405h-3.571312v5.43137h-14.136444v-14.508455h19.865423v6.100991h3.571312v-9.597901z",
    fill: "url(#a)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatex);
export default __webpack_public_path__ + "static/media/latex.9a824b5372da7967bd9c84748f5a0d65.svg";
export { ForwardRef as ReactComponent };